


















































































































































































































































































































































































import axios from 'axios';
import Vue from 'vue';

export default Vue.extend({
  name: 'Detail',

  components: {},

  props: {
    id: {
      type: Number,
      required: true,
    },
  },

  data: () => ({
    loading: true,
    item: null,
  }),

  methods: {
    convertToMarkup(text: string): string {
      // Red excludes
      let res = '';
      let odd = false;
      // @ts-ignore
      text.split('$$$').forEach((part) => {
        res += part;
        odd = !odd;
        res += odd ? '<strong class="red--text text-decoration-line-through">' : '</strong>';
      });
      if (odd) {
        res += '</strong>';
      }

      // Newline handling
      res = res.replace(/\r\n/g, '<br />');

      return res;
    },
    async getDetail() {
      try {
        this.loading = true;
        const resp = await axios.get(this.detailUrl);
        this.item = resp.data;
      } catch (error) {
        window.console.log(`Error getting detail from the server: ${error}`);
      } finally {
        this.loading = false;
      }
    },
    updateFoodSearch(ancestor: any) {
      this.$emit('update_food_search', ancestor);
    },
    updateContaminantSearch(ancestor: any) {
      this.$emit('update_contaminant_search', ancestor);
    },
  },

  computed: {
    foodDescriptionWithMarkup(): string {
      // @ts-ignore
      return this.convertToMarkup(this.item.food_description);
    },
    foodNoteWithMarkup(): string {
      // @ts-ignore
      return this.convertToMarkup(this.item.food_note);
    },
    footnotePresent(): boolean {
      // @ts-ignore
      return !!this.item.food_note.trim();
    },
    baseBackendUrl(): string {
      return this.$store.state.baseBackendUrl;
    },
    detailUrl(): string {
      return `${this.baseBackendUrl}api/v1/rules/${this.id}`;
    },
  },

  async mounted() {
    this.getDetail();
  },
});
